
import React from 'react';
import { AnalysisResult } from '../types';

interface ResultReportProps {
  result: AnalysisResult;
}

const ResultReport: React.FC<ResultReportProps> = ({ result }) => {
  return (
    <div className="max-w-4xl mx-auto px-8 py-12 animate-in fade-in slide-in-from-bottom-20 duration-1000">
      <div className="glass rounded-[32px] overflow-hidden border border-blue-500/20 shadow-2xl shadow-blue-500/5">
        <div className="p-8 md:p-12">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-12">
            <div>
              <h2 className="text-4xl font-display font-black mb-2 uppercase italic tracking-tighter">Savings Breakthrough</h2>
              <div className="flex items-center gap-2 text-green-400 font-bold uppercase tracking-widest text-xs">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                Status: Verified Showroom Price Beaten
              </div>
            </div>
            <div className="bg-blue-600 px-6 py-4 rounded-2xl text-center min-w-[160px]">
              <p className="text-[10px] uppercase font-bold tracking-widest text-white/70 mb-1">Guaranteed Extra</p>
              <p className="text-4xl font-black font-display">{result.guaranteedDiscount}</p>
              <p className="text-[10px] uppercase font-bold tracking-widest text-white/70 mt-1">OFF ON-ROAD PRICE</p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="p-6 bg-white/5 rounded-2xl border border-white/10">
                <h4 className="text-xs uppercase font-bold text-gray-400 mb-4 tracking-widest">Market Intelligence Report</h4>
                <p className="text-lg leading-relaxed text-gray-200">
                  {result.message}
                </p>
              </div>
              
              <div className="flex gap-4">
                <button className="flex-1 px-8 py-4 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-500 transition-all shadow-lg shadow-blue-600/20">
                  Reserve This Price
                </button>
                <button className="px-8 py-4 bg-white/5 border border-white/10 text-white font-bold rounded-xl hover:bg-white/10 transition-all">
                  Download Quote
                </button>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-blue-500/10 blur-3xl rounded-full -z-10"></div>
              <div className="glass p-8 rounded-3xl border border-white/10 space-y-6">
                <div className="flex justify-between items-end border-b border-white/5 pb-4">
                  <span className="text-gray-400 text-sm">Your Current Quote</span>
                  <span className="text-xl font-medium">₹12,45,000</span>
                </div>
                <div className="flex justify-between items-end border-b border-white/5 pb-4">
                  <span className="text-gray-400 text-sm">Elite Additional Discount</span>
                  <span className="text-xl font-medium text-green-400">-{result.estimatedSavings}</span>
                </div>
                <div className="flex justify-between items-end pt-2">
                  <span className="text-blue-400 text-lg font-bold">New On-Road Price</span>
                  <span className="text-3xl font-black font-display text-glow">
                    ₹12,20,000*
                  </span>
                </div>
                <p className="text-[10px] text-gray-500 text-right uppercase tracking-wider italic">
                  *Based on current dealer inventory across major Indian cities
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultReport;
